module.exports = __webpack_public_path__ + "static/media/bliss-docs-website.3243da3d.png";